import { formatDistanceToNow } from 'date-fns';
import type { Locale } from 'date-fns';

import { getDateFnsLocaleObject } from './dateFormatter';

export function getUpdatedTimeLabel(
	date: string | undefined,
	translateUpdated: (key: string) => string,
	locale?: string | Locale
): string {
	if (!date) {
		return '';
	}

	const parsedDate = new Date(date);
	if (Number.isNaN(parsedDate.getTime())) {
		return '';
	}

	const dateFnsLocale =
		typeof locale === 'string'
			? getDateFnsLocaleObject(locale)
			: (locale ?? getDateFnsLocaleObject('en'));

	const elapsedMs = Math.abs(Date.now() - parsedDate.getTime());
	const pastEquivalent = new Date(Date.now() - elapsedMs);

	const updatedTime = formatDistanceToNow(pastEquivalent, {
		addSuffix: false,
		locale: dateFnsLocale,
	});

	return `${translateUpdated('Updated')} ${updatedTime} ${translateUpdated('ago')}`;
}
